/**
 * Hungarian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const hu: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Vezérlőpult',
  'nav.funds': 'Alapok',
  'nav.investments': 'Befektetések',
  'nav.investees': 'Befektetési célpontok',
  'nav.esg': 'ESG Felülvizsgálat',
  'nav.compliance': 'Megfelelőség',
  'nav.reports': 'Jelentések',
  'nav.settings': 'Beállítások',
  'nav.users': 'Felhasználók',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Mutatók',
  'nav.taxonomy': 'EU Taxonómia',
  'nav.filings': 'Bejelentések',
  'nav.calendar': 'Naptár',
  'nav.submit': 'Adatok benyújtása',
  'nav.submissions': 'Benyújtásaim',
  'nav.benchmarks': 'Referenciaértékek',
  'nav.messages': 'Üzenetek',
  'nav.portfolio': 'Portfólió',
  'nav.performance': 'Alap teljesítmény',
  'nav.esgSummary': 'ESG Összefoglaló',
  'nav.pipeline': 'Csővezeték',
  'nav.dueDiligence': 'Átvilágítás',
  'nav.impact': 'Hatásmutatók',
  'nav.sdg': 'FFT Feltérképezés',
  'nav.audit': 'Ellenőrzési nyomvonal',
  'nav.snapshots': 'Adatpillanatképek',
  'nav.knowledgeGraph': 'Tudásgráf',
  'nav.geographic': 'Földrajzi',
  'nav.bi': 'BI Stúdió',
  'nav.ai': 'AI Asszisztens',
  'nav.tasks': 'Feladatok',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Szabályozási monitor',

  // Common Actions
  'action.create': 'Létrehozás',
  'action.edit': 'Szerkesztés',
  'action.delete': 'Törlés',
  'action.save': 'Mentés',
  'action.cancel': 'Mégsem',
  'action.submit': 'Benyújtás',
  'action.approve': 'Jóváhagyás',
  'action.reject': 'Elutasítás',
  'action.download': 'Letöltés',
  'action.export': 'Exportálás',
  'action.import': 'Importálás',
  'action.filter': 'Szűrés',
  'action.search': 'Keresés',
  'action.refresh': 'Frissítés',
  'action.close': 'Bezárás',
  'action.back': 'Vissza',
  'action.next': 'Következő',
  'action.previous': 'Előző',
  'action.viewAll': 'Összes megtekintése',
  'action.viewDetails': 'Részletek megtekintése',
  'action.generate': 'Generálás',
  'action.signOut': 'Kijelentkezés',
  'action.addNew': 'Új hozzáadása',
  'action.invite': 'Meghívás',

  // Statuses
  'status.draft': 'Piszkozat',
  'status.submitted': 'Benyújtva',
  'status.validated': 'Érvényesítve',
  'status.approved': 'Jóváhagyva',
  'status.rejected': 'Elutasítva',
  'status.pending': 'Függőben',
  'status.inProgress': 'Folyamatban',
  'status.overdue': 'Késedelmes',
  'status.compliant': 'Megfelelő',
  'status.filed': 'Bejelentve',
  'status.active': 'Aktív',
  'status.inactive': 'Inaktív',
  'status.closed': 'Lezárt',
  'status.fundraising': 'Tőkegyűjtés',
  'status.investing': 'Befektetés',
  'status.harvesting': 'Betakarítás',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Portfólió áttekintés',
  'dashboard.complianceStatus': 'Megfelelőségi állapot',
  'dashboard.collectionProgress': 'Gyűjtés előrehaladása',
  'dashboard.activityFeed': 'Tevékenység',
  'dashboard.quickActions': 'Gyorsműveletek',
  'dashboard.investmentPipeline': 'Befektetési csővezeték',
  'dashboard.totalFunds': 'Összes alap',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktív befektetések',
  'dashboard.totalInvestees': 'Befektetési célpontok',
  'dashboard.recentActivity': 'Legutóbbi tevékenység',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Összes kötelezettségvállalás',
  'lp.capitalCalled': 'Lehívott tőke',
  'lp.distributed': 'Kiosztott',
  'lp.netPosition': 'Nettó pozíció',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Alap teljesítmény',
  'lp.esgSummary': 'ESG Összefoglaló',
  'lp.reportLibrary': 'Jelentéskönyvtár',
  'lp.taxonomyAligned': 'Taxonómiához igazított',
  'lp.paiCoverage': 'PAI Lefedettség',
  'lp.portfolioPerformance': 'LP Portfólió teljesítmény',

  // Fund Labels
  'fund.name': 'Alap neve',
  'fund.code': 'Alap kódja',
  'fund.vintage': 'Alapítás éve',
  'fund.size': 'Alap mérete',
  'fund.targetSize': 'Célméret',
  'fund.currency': 'Pénznem',
  'fund.strategy': 'Stratégia',
  'fund.status': 'Állapot',
  'fund.sfdrCategory': 'SFDR Kategória',
  'fund.geographyFocus': 'Földrajzi fókusz',
  'fund.sectorFocus': 'Szektorfókusz',

  // Form Labels
  'form.name': 'Név',
  'form.email': 'E-mail',
  'form.country': 'Ország',
  'form.amount': 'Összeg',
  'form.currency': 'Pénznem',
  'form.date': 'Dátum',
  'form.description': 'Leírás',
  'form.notes': 'Megjegyzések',
  'form.type': 'Típus',
  'form.period': 'Időszak',
  'form.year': 'Év',
  'form.required': 'Kötelező',
  'form.optional': 'Opcionális',

  // Table Headers
  'table.fund': 'Alap',
  'table.commitment': 'Kötelezettségvállalás',
  'table.called': 'Lehívott',
  'table.distributed': 'Kiosztott',
  'table.tvpi': 'TVPI',
  'table.status': 'Állapot',
  'table.regulation': 'Szabályozás',
  'table.filingType': 'Bejelentés típusa',
  'table.reportingPeriod': 'Időszak',
  'table.createdAt': 'Létrehozva',
  'table.actions': 'Műveletek',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'EU Taxonómia',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Adatteljessség',
  'compliance.nextDeadline': 'Következő határidő',

  // Reports
  'report.quarterly': 'Negyedéves jelentés',
  'report.annual': 'Éves jelentés',
  'report.paiStatement': 'PAI Nyilatkozat',
  'report.taxonomyReport': 'Taxonómia jelentés',
  'report.generatedAt': 'Generálva',
  'report.version': 'Verzió',

  // General
  'general.loading': 'Betöltés...',
  'general.noData': 'Nincs elérhető adat',
  'general.error': 'Hiba történt',
  'general.retry': 'Újrapróbálás',
  'general.total': 'Összesen',
  'general.page': 'Oldal',
  'general.of': '/',
  'general.showing': 'Megjelenítve',
  'general.results': 'eredmény',
  'general.language': 'Nyelv',
  'general.english': 'Angol',
  'general.french': 'Francia',

  // Tour
  'tour.takeTour': 'Körúnézés indítása',
  'tour.skip': 'Kihagyás',
  'tour.next': 'Következő',
  'tour.prev': 'Előző',
  'tour.finish': 'Befejezés',
};
